import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type { DeleteAssetTypeMutation } from '#/graphql/types';
import { deleteAssetType } from '#/graphql/mutations';
import { GET_ASSET_PROPS_COUNTS } from '../../hooks/useAssetPropsCountsQuery';

const q = gql(deleteAssetType);

const useAssetTypeDelete = () => {
  const [mutation, result] = useMutation<DeleteAssetTypeMutation>(q);
  const deleteAssetType = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries: [{ query: GET_ASSET_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteAssetType', undefined) as { errors: string[] };
    },
    [mutation],
  );

  return { deleteAssetType, result };
};

export default useAssetTypeDelete;
